import React, { useState } from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  View,
} from '@uncinc/react-drupal-core';

const PartnersOverview = ({ display, fullWidth }) => {
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <Container className="ParagraphContentOverview">
      <View
        id="taxonomy_overview"
        display={display}
        page={currentPage}
        setCurrentPage={setCurrentPage}
        fullWidth={fullWidth}
        type="partners"
      />
    </Container>
  );
};

export default PartnersOverview;
